const $imagePopups = document.querySelectorAll('.img-popup');
const $contentPopups = document.querySelectorAll('.content-popup');
const $videoPopups = document.querySelectorAll('.video-popup');

const fn = {
    init: () => {
        (function ($) {
            'use strict';
            if ($($imagePopups).length) {
                fn.setupImagePopup();
            }
            if ($($contentPopups).length) {
                fn.setupContentPopup();
            }
            if ($($videoPopups).length) {
                fn.setupVideoPopup();
            }
        })(jQuery);
    },

    setupImagePopup: () => {
        var groups = {};
        $($imagePopups).each(function() {
            var id = parseInt($(this).attr('data-group'), 10);

            if (!groups[id]) {
                groups[id] = [];
            }

            groups[id].push(this);
        });

        $.each(groups, function() {
            $(this).magnificPopup({
                type: 'image',
                closeOnContentClick: true,
                closeBtnInside: false,
                gallery: { enabled: true },
            });
        });
    },

    setupContentPopup: () => {
        var groups = {};
        $($contentPopups).each(function() {
            var id = parseInt($(this).attr('data-group'), 10);

            if (!groups[id]) {
                groups[id] = [];
            }

            groups[id].push(this);
        });

        $.each(groups, function() {
            $(this).magnificPopup({
                type: 'ajax',
                closeOnContentClick: true,
                closeBtnInside: false,
                gallery: { enabled: true },
                fixedContentPos: true,
            });
        });
    },

    setupVideoPopup: () => {
        var groups = {};
        $($videoPopups).each(function() {
            var id = parseInt($(this).attr('data-group'), 10);

            if (!groups[id]) {
                groups[id] = [];
            }

            groups[id].push(this);
        });

        $.each(groups, function() {
            $(this).magnificPopup({
                type: 'iframe',
                closeOnContentClick: true,
                closeBtnInside: false,
                gallery: { enabled: true },
                fixedContentPos: true,
            });
        });
    },
};

export default {
    can: () => $imagePopups.length || $contentPopups.length || $videoPopups.length,
    run: fn.init,
};
